"use strict";
exports.__esModule = true;
exports.IntersectionOf = void 0;
var functions_1 = require("./functions");
/**
 * A small class to help with constructing larger intersection checkers.
 *
 * @public
 */
var IntersectionOf = /** @class */ (function () {
    function IntersectionOf(ptt) {
        this.ptt = ptt;
    }
    /**
     * Finalise and return the partial type guard for this builder.
     */
    IntersectionOf.prototype.get = function () {
        return this.ptt;
    };
    /**
     * Add a new option for this intersection.
     */
    IntersectionOf.prototype["with"] = function (ptu) {
        return new IntersectionOf(functions_1.isIntersection(this.ptt, ptu));
    };
    return IntersectionOf;
}());
exports.IntersectionOf = IntersectionOf;
//# sourceMappingURL=intersectionof.js.map